import { dictateReengagementFlag } from '@heidi/dictate/flags';

export const DICTATE_REENGAGEMENT_FLAG_KEY = dictateReengagementFlag.key;
export const DICTATE_REENGAGEMENT_VIEW_EXPERIMENT_KEY = 'dictate-reengagement-view-v1';

export const DICTATE_REENGAGEMENT_HINT_VERSIONS = [
  'canvas_delayed_hint',
  'ask_heidi_mic_tooltip',
] as const;
export type DictateReengagementHintVersion =
  (typeof DICTATE_REENGAGEMENT_HINT_VERSIONS)[number];
